import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getText, trackGA } from 'misc/helpers';

class CookieInfo extends Component {
    render = () => {
        return (
            <div className="main-layout">
                <div className="main-content">
                    <Link to="/login">
                        <div className="agreement-back-link">
                            <img src="assets/images/agreement/back_arrow.svg" alt="" /> <span>{getText('_1_3_TextBack', 'Tillbaka')}</span>
                        </div>
                    </Link>
                    <div className="agreement-viewer">
                        <div className="agreement-document">
                            <h2>{getText('_cookies_titel1','Vad är cookies?')}</h2>
                            <p>{getText('_cookies_text1','En cookie är en liten datafil med text som sparas i din webbläsare för att på olika sätt komma ihåg dig och ditt besök samt bidra till en bättre upplevelse och funktion för dig. Det finns två typer av cookies, permanenta och sessionscookies. Permanenta cookies lagras som en fil på din dator eller mobil under en viss tid tills du själv, eller servern som sänt dem, raderar dem. Sessioncookies lagras tillfälligt och försvinner när du stänger din webbläsare.')}</p>
                            <h2>{getText('_cookies_titel2','Varför använder Digimail cookies?')}</h2>
                            <p>{getText('_cookies_text2','Vi använder cookies för att kunna ge dig som besökare bättre service.\n\nI Digimail använder vi något som kallas persistent cookies, vilket betyder att denna cookies sparar en fil en kortare tid på din dator. Den används exempelvis för att hemsidan ska känna igen dig och de val du gjort vid ett tidigare besök.\n\nPost- och telestyrelsen är tillsynsmyndighet på området, läs gärna mer om cookies på deras webbplats.')}</p>
                            <h2>{getText('_cookies_titel3','Hur väljer man bort cookies?')}</h2>
                            <p>{getText('_cookies_text3','Samtycker du inte till att cookies används kan du rensa och stänga av cookies i din webbläsare. Vissa webbläsare (exempelvis Googles ”Chrome”) kan du nyttja i ett så kallat inkognitoläge då webbläsaren automatiskt raderar alla cookies när du stänger ner den.')}</p>
                        </div>
                    </div>
                    <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        agreement: state.agreement
    };
};

export default connect(mapStateToProps)(CookieInfo);



// WEBPACK FOOTER //
// ./src/components/views/CookieInfo.js